import React, { useContext, useEffect, useState } from 'react';

import { RestApiContext } from './RestApiContext';
import { useAggregatedState } from '../../helpers';

export const UserContext = React.createContext(null);

const { Provider } = UserContext;
export const UserProvider = ({ ...props }) => {
    const [state, setState] = useAggregatedState({
        me: null
    });

    const apiClient = useContext(RestApiContext);

    const getMeAsync = async () => {
        try {
            const me = await apiClient.getMeAsync();
            setState({ me });
        } catch (e) {
            setState({ me: null });
            console.debug(e);
        }
    }

    const getCurrentUserInfo = () => {
        const { me } = state;
        return me;
    }

    const isUserInRole = (roleName) => {
        const { me } = state;
        if (me === null || me.roles === null) return false;
        if (me.roles.length === 0) return false;
        const role = me.roles.find(x => x.roleName === roleName);
        return role !== null && role !== undefined;
    }

    const isUserInRoles = (roleNames) => {
        const { me } = state;
        if (me === null || me.roles === null) return false;
        if (me.roles.length === 0) return false;
        const role = me.roles.find(x => roleNames.find(n => x.roleName === n));
        return role !== null && role !== undefined;
    }

    return (
        <Provider value={{
            state,
            getMeAsync,
            getCurrentUserInfo,
            isUserInRole,
            isUserInRoles,
        }}>
            {props.children}
        </Provider>
    );
}